import { getActiveSerial } from "../services/activeDevice";

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    FaBars,
    FaChevronDown,
    FaUserCircle,
    FaSignOutAlt,
    FaMicrochip,
    FaBell
} from "react-icons/fa";

import "../styles/topbar.css";

// ---------------------------------------------------------
// "John Doe" -> "JD"  |  "Ali" -> "A"  |  empty -> "U"
// ---------------------------------------------------------
function initials(name) {

    if (!name) return "U";

    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part[0]?.toUpperCase())
        .join("");
}

export default function Topbar({

    deviceStatus,
    setMenuOpen,
    notifCount = 0,

    // Optional overrides so the same topbar can be reused on
    // pages that aren't showing a single live device (e.g. the
    // Devices list). Dashboard passes the real active serial.
    serial,
    title,
    subtitle

}) {

    const [profileOpen, setProfileOpen] = useState(false);
    const profileRef = useRef(null);
    const navigate = useNavigate();
    const [activeSerial, setActiveSerial] = useState(
    serial || getActiveSerial()
);

const [status, setStatus] = useState(deviceStatus || "Offline");
    // Login.jsx stores these as separate keys, not a "user" blob
    const fullName = localStorage.getItem("userName");

    // ---------------- Close the profile menu on outside click / Escape ----------------
    useEffect(() => {

        if (!profileOpen) return;

        function handleClick(e) {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setProfileOpen(false);
            }
        }

        function handleKey(e) {
            if (e.key === "Escape") setProfileOpen(false);
        }

        document.addEventListener("mousedown", handleClick);
        document.addEventListener("keydown", handleKey);

        return () => {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("keydown", handleKey);
        };

    }, [profileOpen]);
    

    function goTo(path) {
        setProfileOpen(false);
        navigate(path);
    }

    function logout() {
        localStorage.clear();
        navigate("/login");
    }

    return (

        <header className="topbar">

            {/* ---------- Left: menu toggle + device name/status ---------- */}
            <div className="topbarLeft">

                <button
                    className="menuBtn"
                    onClick={() => setMenuOpen(true)}
                    aria-label="Open menu"
                >
                    <FaBars />
                </button>

                <div className="deviceHeader">

                    <h2>{title || activeSerial}</h2>

                    <p>{subtitle || "Real-Time Solar Monitoring"}</p>

                    {!title && (

                        <div className="deviceStatus">

                            <span
                                className={
                                    deviceStatus === "Online"
                                        ? "statusDot online"
                                        : "statusDot offline"
                                }
                            />

                            <span>
                                {deviceStatus === "Online" ? "ONLINE" : "OFFLINE"}
                            </span>

                        </div>

                    )}

                </div>

            </div>

            {/* ---------- Right: notifications + profile ---------- */}
            <div className="topbarRight">

                <button
                    className="notifBtn"
                    aria-label={
                        notifCount > 0
                            ? `Notifications, ${notifCount} unread`
                            : "Notifications"
                    }
                >
                    <FaBell />

                    {notifCount > 0 && (
                        <span className="notifBadge">
                            {notifCount > 9 ? "9+" : notifCount}
                        </span>
                    )}

                </button>

                <div className="profileWrapper" ref={profileRef}>

                    <button
                        className={profileOpen ? "profile open" : "profile"}
                        onClick={() => setProfileOpen(prev => !prev)}
                        aria-haspopup="menu"
                        aria-expanded={profileOpen}
                    >

                        <span className="avatarCircle">
                            {initials(fullName)}
                        </span>

                        <span>
                            {fullName || "User"}
                        </span>

                        <FaChevronDown className="chevron" />

                    </button>

                    {profileOpen && (

                        <div className="profileMenu" role="menu">

                            <button role="menuitem" onClick={() => goTo("/profile")}>
                                <FaUserCircle />
                                My Profile
                            </button>

                            <button role="menuitem" onClick={() => goTo("/devices")}>
                                <FaMicrochip />
                                My Devices
                            </button>

                            <hr />

                            <button
                                role="menuitem"
                                className="logoutBtn"
                                onClick={logout}
                            >
                                <FaSignOutAlt />
                                Logout
                            </button>

                        </div>

                    )}

                </div>

            </div>

        </header>

    );

}
